import { combineReducers } from 'redux'

import cargo from './cargo'
import fonte from './fonte'

export default combineReducers({
    cargo,
    fonte,
})
